<template>
  <div>
    <v-card>
      <v-card-title>
        Number pool
        <v-spacer></v-spacer>
        <v-btn color="secondary" x-small @click="createNewTask" :disabled="pollTasksLoading||newTaskLoading"><v-icon small>refresh</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-data-table :headers="headers" :items="getTasks" disable-filtering disable-pagination disable-sort hide-default-footer :loading="tasksLoading">
              <template v-slot:item.time_started="{ item }"><span class="body--text">{{ item.time_started | formatDate }}</span></template>
              <template v-slot:item.duration="{ item }"><span class="body--text">{{ item.duration | duration }}</span></template>
              <template v-slot:item.user="{ item }"><span class="body--text">{{ item.user }}</span></template>
              <template v-slot:item.status="{ item }">
                <template v-if="pollTasksLoading&&item.status===202"><v-btn x-small text loading color="body"></v-btn></template>
                <span class="body--text">{{ item.status | statusText }}</span>
              </template>
              <template v-slot:item.message="{ item }"><span class="body--text">{{ item.message }}</span></template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { mapState,mapActions,mapGetters } from 'vuex';
  export default {
    data() {
      return {
        headers: [
          {text:'Time started',value:'time_started'},
          {text:'Duration',value:'duration'},
          {text:'User',value:'user'},
          {text:'Status',value:'status'},
          {text:'Message',value:'message'},
        ],
      }
    },
    computed: {
      ...mapState('numberpoolAdmin',['tasksLoading','newTaskLoading','pollTasksLoading']),
      ...mapGetters('numberpoolAdmin',['getTasks','getNewTask']),
      ...mapGetters('crmUsers',['getCrmUsers']),
    },
    filters: {
      statusText(status){
        let retText = 'Failed';
        if(status===201){retText='Completed'}else 
        if(status===202){retText='Ongoing'}
        return retText;
      },
      duration(time){
        let mins = Math.floor(time / 60);
        let secs = Math.floor(time - mins * 60);
        let ret = (mins>0)?`${mins}m ${secs}s`:`${secs}s`;
        return ret;
      },
    },
    methods: {
      ...mapActions('numberpoolAdmin',['fetchTasks','newTask','pollTasks']),
      async createNewTask(){
        await this.newTask();
        await this.fetchTasks();
      },
    },
    async mounted () {
      await this.fetchTasks();
    },
  }
</script>

<style>
</style>
